import React, { useState } from "react";
import { RENTAL_TEXTILE_LAUNDRY } from "../../../constants";
import { TextField } from "@mui/material";
import DisabledTextField from "../../DisabledTextField";
import CustomAccordion from "../../CustomAccordion";
import DynamicOutputTable from "../../DynamicOutputTable";
import ColumnHeader from "../../ColHeader";
import FormTable from "../../FormTable1/FormTable";
import ApiClient from "../../../apisClient";
import CustomAlert from "../../Alert";

const api = new ApiClient();
const EnergyAccordian = () => {
  const [visibleColumns, setVisibleColumns] = useState({
    input: true,
    input_1: true,
    input_2: false,
    input_3: false,
    input_4: false,
  });
  const [hiddenColumnsOrder, setHiddenColumnsOrder] = useState([]);

  const handleHideColumn = (column) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [column]: false,
    }));
    setHiddenColumnsOrder((prevState) => [...prevState, column]);
  };

  const handleShowColumn = (column) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [column]: true,
    }));
    setHiddenColumnsOrder((prevState) =>
      prevState.filter((col) => col !== column)
    );
  };

  function getLastHiddenColumnName() {
    if (hiddenColumnsOrder.length === 0) {
      return null;
    }
    return hiddenColumnsOrder[hiddenColumnsOrder.length - 1];
  }

  const col = ["input", "input_1", "input_2", "input_3", "input_4"];
  const visibleColumnIds = col.filter((col) => visibleColumns[col]);

  const lastVisibleColumn = visibleColumnIds[visibleColumnIds.length - 1];
  const visibleColumnCount = visibleColumnIds.length;

  const [StandardWashingTemp, setStandardWashingTemp] = useState([60, "", "", "", ""]);
  const [outputVisibleColumns, setOutputVisibleColumns] = useState(visibleColumns);
  const [alertMessage, setAlertMessage] = useState("");
  const [isReset, setIsReset] = useState(false);

  const handleStandardWashingTemp = (event, index) => {
    const value = event.target.value;
    const temp = [...StandardWashingTemp];
    // If the input is empty, set the corresponding state to an empty string
    // Otherwise, parse the value to a float and update the state
    if (value === "") {
      temp[index] = ""; // Set empty string if input is cleared
    } else {
      const parsedValue = parseFloat(value);
      if (!isNaN(parsedValue)) {
        temp[index] = parsedValue; // Set parsed number if it's valid
      }
    }
    setStandardWashingTemp(temp);
  };

  const [StandardDryingTemp, setStandardDryingTemp] = useState([60, "", "", "", ""]);

  const handleStandardDryingTemp = (event, index) => {
    const value = event.target.value;
    const temp = [...StandardDryingTemp];
    if (value === "") {
      temp[index] = ""; // Set empty string if input is cleared
    } else {
      const parsedValue = parseFloat(value);
      if (!isNaN(parsedValue)) {
        temp[index] = parsedValue; // Set parsed number if it's valid
      }
    }
    setStandardDryingTemp(temp);
  };

  const [washingCycleDuration, setWashingCycleDuration] = useState(["", "", "", "", ""]);

  const handleWashingCycleDuration = (event, index) => {
    const value = event.target.value;
    const temp = [...washingCycleDuration];
    if (value === "") {
      temp[index] = ""; // Set empty string if input is cleared
    } else {
      const parsedValue = parseFloat(value);
      if (!isNaN(parsedValue)) {
        temp[index] = parsedValue; // Set parsed number if it's valid
      }
    }
    setWashingCycleDuration(temp);
  };

  const [energySavedPercentage, setEnergySavedPercentage] = useState([]);
  const [submittedData, setSubmittedData] = useState(null);

  //form validation
  const isFormValid = () => {
    for (let i = 0; i < visibleColumnCount; i++) {
      if (
        StandardWashingTemp[i] === "" ||
        StandardDryingTemp[i] === "" ||
        washingCycleDuration[i] === ""
      ) {
        //add mui alert
        setAlertMessage("Please fill all the fields");
        return false;
      }else if(isNaN(StandardWashingTemp[i]) || isNaN(StandardDryingTemp[i]) || isNaN(washingCycleDuration[i])){
        setAlertMessage("Please enter valid number");
        return false;
      }else if(StandardWashingTemp[i] < 0 || StandardDryingTemp[i] < 0 || washingCycleDuration[i] < 0){
        setAlertMessage("Please enter positive number");
        return false;
    }else{
      setAlertMessage("");
    }

    }
    return true;
  };

  //handle submit payload response
  const handleSubmit = async () => {
    if(!isFormValid()){
      return
    }
    setIsReset(false);
    const payload = {
      washing_temp: StandardWashingTemp.filter((temp) => temp !== "").map(parseFloat),
      drying_temp: StandardDryingTemp.filter((temp) => temp !== "").map(parseFloat),
      duration: washingCycleDuration.filter((duration) => duration !== "").map(parseFloat),
    };
    try {
      const response = await api.post("/api/v1/energy-efficiency", payload);
      setEnergySavedPercentage(response["output"]);
      setOutputVisibleColumns(visibleColumns);
    } catch (error) {
      console.error("Fetch error:", error);
    }
        setSubmittedData(payload);
  };

  //handle reset
  const handleReset = () => {
    setStandardWashingTemp([60, "", "", "", ""]);
    setStandardDryingTemp([60, "", "", "", ""]);
    setWashingCycleDuration(["", "", "", "", ""]);
    setIsReset(true);
  }


  const formTableRows = [
    {
      label: "",
      input: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[0]}
          onRemove={() => handleHideColumn("input")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input"}
          nextColumnId="input_1"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_1: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[1]}
          onRemove={() => handleHideColumn("input_1")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_1"}
          nextColumnId="input_2"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_2: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[2]}
          onRemove={() => handleHideColumn("input_2")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_2"}
          nextColumnId="input_3"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_3: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[3]}
          onRemove={() => handleHideColumn("input_3")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_3"}
          nextColumnId="input_4"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_4: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[4]}
          onRemove={() => handleHideColumn("input_4")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_4"}
          nextColumnId={getLastHiddenColumnName()}
          visibleColumnCount={visibleColumnCount}
        />
      ),
    },
    {
      label: "Standard washing temperature (°C)",
      input: (
        <DisabledTextField
          key="1"
          width={"140px"}
          variant={"filled"}
          value={60}
        />
      ),
      input_1: (
        <TextField
          key="2"
          size="small"
          className="input-tf"
          value={StandardWashingTemp[1]}
          onChange={(e) => handleStandardWashingTemp(e, 1)}
          placeholder="Enter temperature"
        />
      ),
      input_2: (
        <TextField
          key="3"
          size="small"
          className="input-tf"
          value={StandardWashingTemp[2]}
          onChange={(e) => handleStandardWashingTemp(e, 2)}
          placeholder="Enter temperature"
        />
      ),
      input_3: (
        <TextField
          key="4"
          size="small"
          className="input-tf"
          value={StandardWashingTemp[3]}
          onChange={(e) => handleStandardWashingTemp(e, 3)}
          placeholder="Enter temperature"
        />
      ),
      input_4: (
        <TextField
          key="5"
          size="small"
          className="input-tf"
          value={StandardWashingTemp[4]}
          onChange={(e) => handleStandardWashingTemp(e, 4)}
          placeholder="Enter temperature"
        />
      ),
    },
    {
      label: "Standard drying temperature (°C)",
      input: (
        <DisabledTextField
          key="1"
          width={"140px"}
          variant={"filled"}
          value={60}
        />
      ),
      input_1: (
        <TextField
          key="2"
          size="small"
          className="input-tf"
          value={StandardDryingTemp[1]}
          onChange={(e) => handleStandardDryingTemp(e, 1)}
          placeholder="Enter temperature"
        />
      ),
      input_2: (
        <TextField
          key="3"
          size="small"
          className="input-tf"
          value={StandardDryingTemp[2]}
          onChange={(e) => handleStandardDryingTemp(e, 2)}
          placeholder="Enter temperature"
        />
      ),
      input_3: (
        <TextField
          key="4"
          size="small"
          className="input-tf"
          value={StandardDryingTemp[3]}
          onChange={(e) => handleStandardDryingTemp(e, 3)}
          placeholder="Enter temperature"
        />
      ),
      input_4: (
        <TextField
          key="5"
          size="small"
          className="input-tf"
          value={StandardDryingTemp[4]}
          onChange={(e) => handleStandardDryingTemp(e, 4)}
          placeholder="Enter temperature"
        />
      ),
    },
    {
      label: "Washing and drying cycle duration (hrs):",
      input: (
        <TextField
          key="1"
          size="small"
          className="input-tf"
          placeholder="Enter duration"
          value={washingCycleDuration[0]}
          name="0"
          onChange={(e) => handleWashingCycleDuration(e, 0)}
        />
      ),
      input_1: (
        <TextField
          key="2"
          size="small"
          className="input-tf"
          placeholder="Enter duration"
          value={washingCycleDuration[1]}
          name="1"
          onChange={(e) => handleWashingCycleDuration(e, 1)}
        />
      ),
      input_2: (
        <TextField
          key="3"
          size="small"
          className="input-tf"
          placeholder="Enter duration"
          value={washingCycleDuration[2]}
          name="2"
          onChange={(e) => handleWashingCycleDuration(e, 2)}
        />
      ),
      input_3: (
        <TextField
          key="4"
          size="small"
          className="input-tf"
          placeholder="Enter duration"
          value={washingCycleDuration[3]}
          name="3"
          onChange={(e) => handleWashingCycleDuration(e, 3)}
        />
      ),
      input_4: (
        <TextField
          key="5"
          size="small"
          className="input-tf"
          placeholder="Enter duration"
          value={washingCycleDuration[4]}
          name="4"
          onChange={(e) => handleWashingCycleDuration(e, 4)}
        />
      ),
    },
  ];

  const section_2 = [
    {
      title: "Energy efficiency",
      content: (
        <>
          <FormTable
            rows={formTableRows}
            onSubmit={handleSubmit}
            onReset={handleReset}
            visibleColumns={visibleColumns}
            handleHideColumn={handleShowColumn}
          />
          {alertMessage && <CustomAlert text={alertMessage} />}
          {submittedData && !alertMessage && !isReset && (
            <DynamicOutputTable
              visibleColumns={outputVisibleColumns}
              title={"Energy efficiency"}
              data={[
                {
                  label: "Standard washing temperature (°C)",
                  value1: StandardWashingTemp[0],
                  value2: StandardWashingTemp[1],
                  value3: StandardWashingTemp[2],
                  value4: StandardWashingTemp[3],
                  value5: StandardWashingTemp[4],
                },
                {
                  label: "Standard drying temperature (°C)",
                  value1: StandardDryingTemp[0],
                  value2: StandardDryingTemp[1],
                  value3: StandardDryingTemp[2],
                  value4: StandardDryingTemp[3],
                  value5: StandardDryingTemp[4],
                },
                {
                  label: "Washing and drying cycle duration (hrs)",
                  value1: washingCycleDuration[0],
                  value2: washingCycleDuration[1],
                  value3: washingCycleDuration[2],
                  value4: washingCycleDuration[3],
                  value5: washingCycleDuration[4],
                },
                {
                  label: "Energy saved percentage",
                  value1: energySavedPercentage[0],
                  value2: energySavedPercentage[1],
                  value3: energySavedPercentage[2],
                  value4: energySavedPercentage[3],
                  value5: energySavedPercentage[4],
                },
              ]}
            />
          )}
        </>
      ),
    },
  ];

  return <CustomAccordion sections={section_2} isExpanded={true} />;
};

export default EnergyAccordian;
